import Map from '../views/map/Map'

const map =
{
    routes :
    [
        { path : '/', component : Map }
    ],
    settings:
    {
        layout :
        {
            config :
            {
                navbar : { display : false } ,
                toolbar: { display : false } ,
                footer : { display : false }
            }
        }
    }
};

export default map ;


// WEBPACK FOOTER //
// ./src/app/routes/map.js